import { platformRefreshSize } from './platformRefreshSize'

export function platformWatchSize() {
  platformRefreshSize()

  window.addEventListener('resize', platformRefreshSize, true)
}
